module.exports = __webpack_public_path__ + "section/next-page/img/arrow.svg?hash=e256b2459264c05ff92f6ef7ca13aec2"


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/asset-loader!./LeLab.LogAlto.Web/src/modules/section/next-page/img/arrow.svg
 ** module id = 24
 ** module chunks = 0 1
 **/